<div class="cause-selection" [ngClass]="config?.formTheme + (is_agent?' agent-view':'')">
  <div class="head">
    <div class="title">Select the Causes</div>
  </div>
  <div class="list-section">
    <div *ngFor="let item of cause_list; let i = index" class="cause" id="cause-{{item?.sip_cause}}" [ngClass]="{'active': selected.includes(item?.sip_cause), 'disabled': disable_status_regex.test(item?.status?.toString())}" (click)="checklist(item, $event)">
      <div class="logo"><em class="material-icons">{{item?.icon}}</em></div>
      <div class="title">{{item?.title}}</div>
      <div *ngIf="is_agent" class="status">{{vars.sip_status[item.status].text}}</div>
      <div class="right">
        <div *ngIf="(selected.includes(item?.sip_cause) || disable_status_regex.test(item?.status?.toString())) && params?.utm_source?.match('internal_impact_calling')" class="amount">
          <span class="symbol" [innerHTML]="util.getCurrencyIcon(config.currency).symbol"></span>
          <div *ngIf="item?.lock_amount" class="amount">{{item?.amount}}</div>
          <input *ngIf="!item?.lock_amount"
            type="{{is_mobile ? 'tel' : 'number'}}"
            class="amount-input"
            id="amt-in-{{i}}"
            min="{{config.paymentDetails.min_donation}}"
            max="50000000"
            [value]="item?.amount"
            (input)="changeAmount(item?.sip_cause, $event)"
            (focusout)="changeAmount(item?.sip_cause, $event)"
            pattern="[0-9]+"
          >
        </div>
        <div *ngIf="selected.includes(item?.sip_cause) && !params?.utm_source?.match('internal_impact_calling')" class="amount" [innerHTML]="util.formatAmount(config?.amount, config?.currency)"></div>
        <div class="check-mark"><em *ngIf="selected.includes(item?.sip_cause)" class="material-icons">done</em></div>
      </div>
    </div>
    <div *ngIf="min_sip_error" class="min-error">Medical SIP mandatory</div>
    <div *ngIf="show_min_error" class="min-error">Minimum amount should be {{util.formatAmount(config?.paymentDetails?.min_donation, config?.currency)}} per cause</div>
  </div>
  <div *ngIf="config?.show_start_date" class="datepicker">
    <mat-form-field (click)="picker.open()">
      <mat-label>Choose a start date</mat-label>
      <input matInput [matDatepicker]="picker" readonly="true" [min]="today" [max]="maxStartDate" (dateChange)="onDateSelected($event)">
      <!-- <mat-hint *ngIf="!selectedDate">DD/MM/YYYY</mat-hint> -->
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </div>
</div>
